var __decorate=this&&this.__decorate||function(e,r,t,o){var a,i=arguments.length,l=i<3?r:null===o?o=Object.getOwnPropertyDescriptor(r,t):o;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,r,t,o);else for(var d=e.length-1;d>=0;d--)(a=e[d])&&(l=(i<3?a(l):i>3?a(r,t,l):a(r,t))||l);return i>3&&l&&Object.defineProperty(r,t,l),l};import{Dialog as e}from"@vaadin/dialog";import{customElement as r}from"lit/decorators.js";import{css as t}from"lit";export{dialogHeaderRenderer,DialogHeaderRendererDirective,dialogRenderer,DialogRendererDirective,dialogFooterRenderer,DialogFooterRendererDirective}from"@vaadin/dialog/lit";let OrVaadinDialog=class extends e{static get styles(){return[e.styles,t`
        ::part(header),
        ::part(content) {
          background-color: var(--lumo-contrast-5pct);
        }
        ::part(header) {
          /* Colour header icons (e.g. the close cross) with the primary colour */
          --internal-or-icon-fill: var(--lumo-primary-color);
        }
        ::part(header),
        ::part(footer) {
          padding: var(--lumo-space-l);
        }
        ::part(content) {
          padding: 0 var(--lumo-space-l);
        }
      `]}open(){this.setAttribute("opened","true")}close(){this.toggleAttribute("opened",!1)}};OrVaadinDialog=__decorate([r("or-vaadin-dialog")],OrVaadinDialog);export{OrVaadinDialog};